import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import t from './Testing.type';
import * as TodoListService from '../../../../../services/todo-list.service';
import * as SupplierSuggestion from '../../../../../services/supplierSuggestion.service';
import * as SupplierService from '../../../../../services/supplier.service';
import { ERROR_MESSAGE } from '../../../../../Components/helper';

export const getTestingList = (pramams) => async (dispatch) => {
  const requestId = pramams.requestId || Date.now().toString();
  try {
    const res = await TodoListService.getSampleRequestsTodoListService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_TESTING_REQUESTS_TODOLIST,
        payload: {
          data: res.data.doc,
          totalCount: res.data.totalCount,
          searchText: pramams.searchText,
          isScrolled: pramams.isScrolled,
          sortOrder: pramams.sortOrder,
          sortPropertyName: pramams.sortPropertyName,
          requestId,
        },
      });
    } else {
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setTestingSelectedIds = (idsArr) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_SELECTED_IDS_ARRAY,
      payload: idsArr,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSeasonsAction = (id) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getSeasons(id);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: t.GET_SEASONS,
        payload: res.data,
      });
    } else {
      console.log(res.data.errMsg);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchAllBrandAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllBrands(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: t.GET_MASTERS_BRANDS,
        payload: res.data,
      });
    } else {
      console.log(res.data.errMsg);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSuppliers = (data) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getSupplier(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SUPPLIER,
        payload: res.data,
      });
    } else {
      console.log(res.data.errMsg);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getUserSuppliers = () => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getUserSuppliers();
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_USER_SUPPLIERS,
        payload: res.data,
      });
    } else {
      console.log(res.data.errMsg);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchCategoryAction1 = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params); // API
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_CATEGORY_1,
        payload: res.data,
      });
    } else {
      console.log(res.data.errMsg);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (error) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const fetchCategoryAction2 = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params); // API
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_CATEGORY_2,
        payload: res.data,
      });
    } else {
      console.log(res.data.errMsg);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (error) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const fetchCategoryAction3 = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params); // API
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_CATEGORY_3,
        payload: res.data,
      });
    } else {
      console.log(res.data.errMsg);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (error) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchCategoryAction4 = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params); // API
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_CATEGORY_4,
        payload: res.data,
      });
    } else {
      console.log(res.data.errMsg);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
    return true;
  } catch (error) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
